import SqftStore from "../../../store/sqftStore";
import store from "../../../../../../../store";
import sqftSlabManager from "../../../store/sqftSlabManager";
import sqftShapeIntersectionsManager from "../../../store/sqftShapeIntersectionsManager";
import sqftImageManager from "../../../store/sqftImageManager";
import {
  detectSlabConflicts,
  handleOpenSlabModeConflict
} from "../../../../popup/modalFix/slabFix/slabModeConflictHelper";
import {setSqftSlabConflicts} from "../../../../../../../actions/sqftSlabFunctions";

export const INTERSECTION_MODE = {
  REGULAR: 'regular',
  SLAB: 'slab',
};

export default class ShapeIntersections {
  __shape;

  regularOverlappedWithShapeIds = [];
  slabOverlappedWithShapeIds = [];

  constructor(shape) {
    this.__shape = shape;
  }

  getCurrentModeKey = () => {
    return SqftStore.isSlabMode() ? INTERSECTION_MODE.SLAB : INTERSECTION_MODE.REGULAR;
  }

  getModeKey = (mode = null) => {
    return mode || this.getCurrentModeKey();
  }

  getStorageByMode = (mode = null) => {
    const modeKey = this.getModeKey(mode);

    if (modeKey === INTERSECTION_MODE.SLAB) {
      return this.slabOverlappedWithShapeIds;
    }

    return this.regularOverlappedWithShapeIds;
  }

  setStorageByMode = (ids, mode = null) => {
    const modeKey = this.getModeKey(mode);
    const normalizedIds = Array.isArray(ids) ? [...new Set(ids)] : [];

    if (modeKey === INTERSECTION_MODE.SLAB) {
      this.slabOverlappedWithShapeIds = normalizedIds;
      return;
    }

    this.regularOverlappedWithShapeIds = normalizedIds;
  }

  getOverlappedWithShapeIds = () => {
    return this.getStorageByMode();
  }

  getOverlappedWithShapeIdsByMode = (mode) => {
    return this.getStorageByMode(mode);
  }

  setOverlappedWithShapeIds = (ids) => {
    this.setStorageByMode(ids);
  }

  setOverlappedWithShapeIdsByMode = (ids, mode) => {
    this.setStorageByMode(ids, mode);
  }

  addOverlappedWithShape = (id) => {
    const overlappedIds = this.getStorageByMode();

    if (!overlappedIds.includes(id)) {
      overlappedIds.push(id);
    }
  }

  addOverlappedWithShapeByMode = (id, mode) => {
    const overlappedIds = this.getStorageByMode(mode);

    if (!overlappedIds.includes(id)) {
      overlappedIds.push(id);
    }
  }

  removeOverlappedWithShape = (id) => {
    const modeKey = this.getCurrentModeKey();

    if (modeKey === INTERSECTION_MODE.SLAB) {
      this.slabOverlappedWithShapeIds = this.slabOverlappedWithShapeIds.filter(
        overlappedId => overlappedId !== id
      );
      return;
    }

    this.regularOverlappedWithShapeIds = this.regularOverlappedWithShapeIds.filter(
      overlappedId => overlappedId !== id
    );
  }

  removeOverlappedWithShapeByMode = (id, mode) => {
    const modeKey = this.getModeKey(mode);

    if (modeKey === INTERSECTION_MODE.SLAB) {
      this.slabOverlappedWithShapeIds = this.slabOverlappedWithShapeIds.filter(
        overlappedId => overlappedId !== id
      );
      return;
    }

    this.regularOverlappedWithShapeIds = this.regularOverlappedWithShapeIds.filter(
      overlappedId => overlappedId !== id
    );
  }

  resetCurrentMode = () => {
    this.setStorageByMode([]);
  }

  resetByMode = (mode) => {
    this.setStorageByMode([], mode);
  }

  resetAll = () => {
    this.regularOverlappedWithShapeIds = [];
    this.slabOverlappedWithShapeIds = [];
  }

  /**
   * 1. This will take FIRST intersection between shape and the slab and assign feature from shape to slab
   * 2. Then it will show Slab conflict popup if any slab conflict exists
   */
  handleSlabPlaceholderAndSlabImageIntersections = () => {
    if (!SqftStore.isSlabMode()) {
      return;
    }

    const slabImages = sqftImageManager.getSlabImages();
    const slabPlaceHolderShapes = sqftSlabManager.getSlabPlaceHolderShapes();

    if (!slabImages.length && !slabPlaceHolderShapes.length) {
      return;
    }

    const reduxState = store.getState();
    const isSlabModeConflictOpened = reduxState.sqftModalFixState.isModalFixOpen
      && reduxState.sqftModalFixState.id === 'slabModeConflict';

    if (!isSlabModeConflictOpened) {
      //sqftShapeIntersectionsManager.updateShapesIntersections();
      sqftShapeIntersectionsManager.updateSlabPlaceholderFeatureId();
      sqftShapeIntersectionsManager.updateSlabImagesFeature();
    }

    const shapeIdsWithConflict = detectSlabConflicts();

    if (Array.isArray(shapeIdsWithConflict) && shapeIdsWithConflict.length === 0) {
      store.dispatch(setSqftSlabConflicts([]));
    }

    handleOpenSlabModeConflict(shapeIdsWithConflict).then(() => undefined);
  };
}
